import request from '@/utils/request'
const galleryApi = {
  queryGalleryCategoryList: () => {
    return request({
      url: '/public/gallery/category/list',
      method: 'get'
    })
  },
  queryGalleryCategoryById: (categoryId) => {
    return request({
      url: '/public/gallery/category/info/' + categoryId,
      method: 'get'
    })
  },
  queryGalleryPhotoList: (params) => {
    return request({
      url: '/public/gallery/photo/list',
      method: 'get',
      params
    })
  },
  createGallerySubmission: (data) => {
    return request({
      url: '/public/gallery/submission/create',
      method: 'post',
      data
    })
  }
}

export default galleryApi
